module.exports = __webpack_public_path__ + "static/media/home.4719031f.jpg";